module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Mom’s radar extends so far beyond me. She’s so\nmany people’s mom besides my own. A multispecies\nmom. She’s takes in every stray animal. Drives injured\nbirds to the vet. Carries bugs outside to be reunited with\nloved ones. Apologizes before squashing an ant.")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("She travels with as much as she can possibly carry\nof what everyone might need. Band-aids. Glue. Tape.\nEye dropper. Paper clips. Sewing supplies. Ink remover.\nTravel iron. Nail polish. Pliers. Sunscreen. Thermometer.\nJuice box. Amphibian food.")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Her purse is like a 15-pound rescue van.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Her mind is like a purse. She has everything in\nthere. What to do if the child at the library gets the\nhiccups. Who to call if the park bench has a rough spot\nthat might give a splinter. Where to find a map of Paris\nat midnight in Toledo. How to tell if a cantaloupe is ripe.\nWhat to say if a complete stranger looks a little bit sad.\nWhat to write on a note that will change someone’s\nwhole outlook on life.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d1ed3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mom008.vue
// module id = 75
// module chunks = 0